import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';

export const HeaderBar = ({
  title,
  description,
  onClose,
  ...rest
}: {
  title: string;
  description?: string;
  onClose: () => void;
}) => {
  return (
    <div
      css={css`
        margin-bottom: ${theme.spacing(1)};
      `}
      {...rest}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
        `}
      >
        <Heading level={2}>{title}</Heading>
        <Button variant='secondary' iconName='x' size='large' onClick={onClose} />
      </div>
      {description && <Text>{description}</Text>}
    </div>
  );
};
